import { useQuery } from '@tanstack/react-query';
import { listRecipients } from '../api/recipients.api';
import { teamKeys } from './team.keys';

/**
 * Load the entity's Shared Startup Profile recipients (MYN-54). Disabled
 * until an entity id is known.
 */
export function useRecipients(entityId: string | undefined) {
  return useQuery({
    queryKey: teamKeys.recipients(entityId ?? ''),
    queryFn: () => listRecipients(entityId as string),
    enabled: Boolean(entityId),
  });
}
